import {str, envsafe, bool, url} from 'envsafe'

// Because Next.js deals with transpiling public env vars we have to put manually in as `input`
const env = envsafe({
  ADMIN_ACCESS_GROUP: str({
    default: 'conveyal',
    input: process.env.NEXT_PUBLIC_ADMIN_ACCESS_GROUP
  }),
  API_URL: url({
    devDefault: 'http://localhost:7070',
    input: process.env.NEXT_PUBLIC_API_URL
  }),
  AUTH_DISABLED: bool({
    default: false,
    devDefault: true,
    input: process.env.NEXT_PUBLIC_AUTH_DISABLED
  }),
  BASEMAP_DISABLED: bool({
    default: false,
    input: process.env.NEXT_PUBLIC_BASEMAP_DISABLED
  }),
  CI: bool({
    default: false
  }),
  LOGROCKET: str({
    default: 'fake-token',
    input: process.env.NEXT_PUBLIC_LOGROCKET
  }),
  MAPBOX_ACCESS_TOKEN: str({
    devDefault: 'fake-token',
    input: process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN
  }),
  MAPBOX_STYLE: str({
    default: 'conveyal/cjwu7oipd0bf41cqqv15huoim',
    input: process.env.NEXT_PUBLIC_MAPBOX_STYLE
  }),
  NODE_ENV: str({
    devDefault: 'development',
    choices: ['development', 'test', 'production']
  }),
  PLAUSIBLE_DOMAIN: str({
    default: 'conveyal.dev',
    input: process.env.NEXT_PUBLIC_PLAUSIBLE_DOMAIN
  }),
  VERCEL_ENV: str({
    default: 'development',
    choices: ['development', 'preview', 'production'],
    input: process.env.NEXT_PUBLIC_VERCEL_ENV
  })
})

export default env
